var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "249px",
    height: "270px",
    viewBox: "0 0 249 270",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artwork") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "13.0708554%",
    x2: "40.1757761%",
    y2: "67.7413175%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95ABC2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.1,0 L17.2461538,0 L17.2461538,9.11875 C17.2461538,13.5922565 13.6196603,17.21875 9.14615385,17.21875 L0,17.21875 L0,8.1 C-5.47846538e-16,3.62649353 3.62649353,-2.73094387e-15 8.1,0 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty-States",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.2_No-Purchases",
    transform: "translate(-63.000000, -91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork",
    transform: "translate(63.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-27-Copy-2",
    fill: "#8E99A3",
    points: "112.677043 103.313295 215.272374 131.504342 215.272374 230.148246 112.677043 185.949416"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-27-Copy-3",
    fill: "#A0AAB5",
    transform: "translate(70.897245, 166.944432) scale(-1, 1) translate(-70.897245, -166.944432) ",
    points: "29 103.40999 112.794491 126.825288 112.794491 230.478874 29 185.614083"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fly",
    transform: "translate(85.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.7631892,223.082179 C58.6088501,216.304433 17.944726,216.909415 2.6736242,177.297783 C-11.3222035,140.994077 40.3069352,106.053683 54.7514721,121.35104 C64.9868692,132.190746 51.8674672,147.82309 33.6619116,146.067002 C13.1701537,144.090389 1.05773734,125.764687 5.09818108,106.053683 C13.1129311,66.9543206 74.7333044,41.0852428 77.3311323,39.2832241",
    id: "path",
    stroke: "url(#linearGradient-1)",
    strokeWidth: 3,
    strokeDasharray: "6,7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bee",
    transform: "translate(58.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3668023,30.4814208 C23.0232126,23.2768132 26.3514177,17.8393132 26.3514177,14.1689208 C26.3514177,8.66333217 21.8811532,4.20017077 16.3668023,4.20017077 C10.8524515,4.20017077 6.38218696,8.66333217 6.38218696,14.1689208 C6.38218696,17.8393132 9.71039209,23.2768132 16.3668023,30.4814208 Z",
    id: "Oval",
    fill: "#CED8E5",
    opacity: 0.400000006,
    transform: "translate(16.366802, 17.340796) rotate(-45.000000) translate(-16.366802, -17.340796) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.782187,54.9501708 C48.4385972,47.7455632 51.7668023,42.3080632 51.7668023,38.6376708 C51.7668023,33.1320822 47.2965378,28.6689208 41.782187,28.6689208 C36.2678361,28.6689208 31.7975716,33.1320822 31.7975716,38.6376708 C31.7975716,42.3080632 35.1257767,47.7455632 41.782187,54.9501708 Z",
    id: "Oval-Copy",
    fill: "#CED8E5",
    opacity: 0.400000006,
    transform: "translate(41.782187, 41.809546) scale(-1, -1) rotate(-45.000000) translate(-41.782187, -41.809546) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4",
    transform: "translate(20.876923, 20.031250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#A8B7C5",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DDE5F2",
    mask: "url(#mask-3)",
    transform: "translate(4.992308, 10.875000) rotate(-45.000000) translate(-4.992308, -10.875000) ",
    x: 3.63076923,
    y: 0.90625,
    width: 2.72307692,
    height: 19.9375
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-4-Copy",
    fill: "#DDE5F2",
    mask: "url(#mask-3)",
    points: "2.42673773 0.257532354 4.35224389 -1.6679738 18.4501853 12.4299676 16.5246792 14.3554738"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.3832451,15.7171522 L54.0076923,14.140625",
    id: "Path-7-Copy",
    stroke: "#8696C5",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6601682,12.9984022 L47.2089224,6.44121675",
    id: "Path-7",
    stroke: "#8696C5",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    fill: "#8B9AA8",
    cx: 40.8461538,
    cy: 18.21875,
    rx: 7.26153846,
    ry: 7.25
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-27",
    fill: "#DAE2EC",
    points: "29 127.011673 131.595331 159.568479 131.595331 274.53346 29 230.33463"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-27-Copy",
    fill: "#C5D0D9",
    transform: "translate(172.964745, 202.955446) scale(-1, 1) translate(-172.964745, -202.955446) ",
    points: "130.140078 131.377432 215.789413 159.568479 215.789413 274.53346 130.140078 230.33463"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-17-Copy",
    fill: "#DAE2EC",
    transform: "translate(189.549058, 170.778814) scale(-1, 1) translate(-189.549058, -170.778814) ",
    points: "163.551484 131.309672 130.441545 175.62058 218.309483 210.247957 248.656571 159.350711"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-17",
    fill: "#C5D0D9",
    points: "28.8763611 126.772319 0.197811089 171.510138 101.273918 210.247957 130.804456 159.289954"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.381eb18efb864e7127be7247b922d670.svg";
export { ForwardRef as ReactComponent };